import * as React from "react"
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

interface IProps {
    title: string,
    videoUrl: string,
    onClose: () => void
}

export default function HowToVideoModal(props: Readonly<IProps>): React.ReactNode {
    const [isPopupShown, setIsPopupShown] = React.useState<boolean>(true);

    const toggleModal = (): void => {
        isPopupShown && props.onClose();
        setIsPopupShown(!isPopupShown);
    };

    const closeButton: React.ReactNode = <button className="btn-close" onClick={toggleModal}/>;

    return (
        <Modal className="my-2 info-modal" isOpen={isPopupShown}>
            <ModalHeader toggle={toggleModal} close={closeButton}>
                <div className="d-flex flex-row how-to-video-popup-header">
                    <img alt="info-icon" src="/img/info-icon-active.svg" height={35}/>
                    <h1 className="ml-1">{props.title}</h1>
                </div>
            </ModalHeader>
            <ModalBody>
                <iframe className="how-to-video"
                        src={props.videoUrl}
                        title="YouTube video player"
                        loading="lazy"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen={true}/>
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-primary" type="button" onClick={toggleModal}>Ok, thanks</button>
            </ModalFooter>
        </Modal>
    );
}
